import { updateWishListProducts } from '../../../redux/wishList/reducers/WishListReducer';
import { toggleComparedStateForItems } from '../../../redux/compare/reducers/CompareReducer';
import { CompareActionTypes, ProductGroupFredhopperTypes, WishListActionTypes } from '../../../enums/ActionEnums';
import { setDeliveryPromiseToProducts } from '../../../util/ProductUtil';
import { normalizeProductGroupState, updateProductGroupProducts } from '../../../util/ProductGroupUtil';
export const initialProductGroupFredhopperState = {};
export const loadProductGroupFredhopperReducer = (initialData = null) => {
    if (initialData === null || initialData === void 0 ? void 0 : initialData.productGroupFredhopperId) {
        initialProductGroupFredhopperState[initialData.productGroupFredhopperId] = initialData.products;
    }
    return (state = initialProductGroupFredhopperState, action) => {
        normalizeProductGroupState(state, initialProductGroupFredhopperState);
        switch (action.type) {
            case WishListActionTypes.ADD_PRODUCT:
                return updateProductGroupProducts(state, updateWishListProducts, action, true);
            case WishListActionTypes.REMOVE_PRODUCT:
                return updateProductGroupProducts(state, updateWishListProducts, action, false);
            case CompareActionTypes.COMPARE_UPDATE_PRODUCTS:
                return updateProductGroupProducts(state, toggleComparedStateForItems, action.payload);
            case ProductGroupFredhopperTypes.SET_DELIVERY_PROMISE:
                return Object.assign(Object.assign({}, state), { [action.payload.productGroupId]: setDeliveryPromiseToProducts(state[action.payload.productGroupId], action.payload) });
            case ProductGroupFredhopperTypes.SET_FREDHOPPER_DATA:
                return Object.assign(Object.assign({}, state), action.payload);
            default:
                return state;
        }
    };
};
export const productGroupFredhopperReducer = loadProductGroupFredhopperReducer();
